import { render, staticRenderFns } from "./Ventas.vue?vue&type=template&id=6744535d"
import script from "./Ventas.vue?vue&type=script&lang=js"
export * from "./Ventas.vue?vue&type=script&lang=js"
import style0 from "./Ventas.vue?vue&type=style&index=0&id=6744535d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports